import { z } from 'zod';

export const nameSchema = z.string().min(3, 'Name must be at least 3 characters long.');
